export enum EApplicationSource {
  IREMBO_HUB = 'IREMBO_HUB',
  IREMBO_GOV_2_0 = 'IREMBO_GOV_2_0',
}
